import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.PopupXeroAccrualReport.FormPopupContent', {
    title: 'Accrual Report for Xero',
    description:
        'The resulting .csv will contain line items that match the criteria defined in the report filter. This file is ready to be uploaded into Manual Journal Entry.',
    narrationFieldTitle: 'Narration',
    narrationFieldPlaceholder: 'Enter narration',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Select the date',
    accrualAccountFieldTitle: 'Accrual Account',
    accrualAccountFieldPlaceholder: 'Enter accrual account',
    learnMoreText: 'Learn more',
    createButtonTitle: 'Create',
});
